/**
 * The editorial panel beside the sign-in and registration forms.
 *
 * This is the first thing a prospective user sees, so it does the positioning
 * work the form cannot: what ALFIE is, in one line, and the three claims that
 * distinguish it from a chat window with a legal prompt. It is a deliberately
 * fixed dark surface in both themes — the panel *is* the brand mark — so its
 * few literal colours live in `styles/components/auth.css` rather than being
 * theme tokens.
 */
import { BrandMark } from '@/components/Layout';

const CLAIMS: [string, string][] = [
  ['Grounded, not generated', 'Answers are assembled from retrieved authority and abstain when nothing clears the bar.'],
  ['Every citation checked', 'Existence, good-law status and quote fidelity are verified deterministically — before you see the draft.'],
  ['Your record, your engine', 'Ground answers in the matter file, and run on the model you choose — including one on your own hardware.'],
];

export function AuthAside() {
  return (
    <aside className="auth-aside">
      <div className="auth-brand">
        <BrandMark size={32} />
        <span>ALFIE</span>
      </div>

      <div>
        <p className="eyebrow">AI Legal Framework &amp; Intelligence Engine</p>
        <h2 className="mt-4">
          Grounded legal AI,
          <br />
          from research to draft.
        </h2>
        <p className="lede">
          Research an issue, draft the argument, and check every citation in one place — with the
          record, the authority and the reasoning attached to the work product.
        </p>
      </div>

      <div className="stack">
        {CLAIMS.map(([title, detail]) => (
          <div className="feat" key={title}>
            <div>
              <div className="feat-t">{title}</div>
              <div className="feat-d">{detail}</div>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
